/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * How-to-play step with icon
 * @export
 * @interface SurfaceHowToPlayStep
 */
export interface SurfaceHowToPlayStep {
    /**
     * 
     * @type {string}
     * @memberof SurfaceHowToPlayStep
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceHowToPlayStep
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceHowToPlayStep
     */
    icon?: string;
}

/**
 * Check if a given object implements the SurfaceHowToPlayStep interface.
 */
export function instanceOfSurfaceHowToPlayStep(value: object): value is SurfaceHowToPlayStep {
    return true;
}

export function SurfaceHowToPlayStepFromJSON(json: any): SurfaceHowToPlayStep {
    return SurfaceHowToPlayStepFromJSONTyped(json, false);
}

export function SurfaceHowToPlayStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceHowToPlayStep {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function SurfaceHowToPlayStepToJSON(json: any): SurfaceHowToPlayStep {
    return SurfaceHowToPlayStepToJSONTyped(json, false);
}

export function SurfaceHowToPlayStepToJSONTyped(value?: SurfaceHowToPlayStep | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

